import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap'
import MESSAGES from 'core/data-model/constants/messages'
import { setNotificationMessage } from 'quick-quote/notification/actions'
import { enableFnaPhase } from 'quick-quote/fna/actions'
import { getToggles } from 'quick-quote/feature-toggles'
import { getAppConfig } from 'deploy-env/app-config'
import { getUserAgentType } from 'identity/selectors'
import { getSelectedDisplayBasicPlanCode } from 'quick-quote/product-selection/selectors'
import { IsRealDevice } from 'e-submission/utils'
import values from 'core/data-model/constants/values'

const ProceedToFnaButton = (props) => {
  const { disabled } = props
  const dispatch = useDispatch()
  const currentUserRole = useSelector(getUserAgentType)
  const basicPlanCode = useSelector(getSelectedDisplayBasicPlanCode)

  const handleClick = () => {
    if (getToggles().ENABLE_FNA_QQ_NAV_V2) {
      dispatch(setNotificationMessage({ type: 'ConfirmToFNA' }))
    } else {
      dispatch(enableFnaPhase())
    }
  }

  const RealButton = (
    <Button className="e-submission" color="primary" onClick={handleClick} disabled={disabled}>
      {MESSAGES.PROCEED_TO_FNA}
    </Button>
  )

  /* istanbul ignore next */
  const isBanca = currentUserRole === values.AGENT_TYPE_LB
  if (isBanca) {
    // Not allow Banca to use web view to esubmission flow
    if (!IsRealDevice && getToggles().ENABLE_BANCA_BLOCK_ESUB_WEB_VIEW) return null

    // Not allow Banca to use except product in list to allow
    if (
      getToggles().ENABLE_ESUB_BTN_FOR_LB_WITH_PRODUCTLIST &&
      (getAppConfig().ESUB_BTN_FOR_LB_WITH_PRODUCTLIST.includes(props.basicPlanCode) ||
        getAppConfig().ESUB_BTN_FOR_LB_WITH_PRODUCTCATEGORY.includes(props.productCategory))
    ) {
      return RealButton
    } else {
      return null
    }
  } else if (
    currentUserRole === values.AGENT_TYPE_FSE ||
    currentUserRole === values.AGENT_TYPE_BANCA ||
    getToggles().ENABLE_REVISE_FNA
  ) {
    return null
  }

  return RealButton
}

export default ProceedToFnaButton
